import { Link } from 'react-router-dom';

export default function Safety() {
  return (
    <section className="relative bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-14">
            <div className="lg:w-1/2 relative">
              <div className="rounded-2xl overflow-hidden relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20security%20and%20trust%20concept%20image%2C%20warm%20cream%20background%20with%20modern%20shield%20symbol%2C%20soft%20natural%20lighting%2C%20contemporary%20editorial%20style%2C%20professional%20atmosphere%2C%20abstract%20circular%20geometric%20elements%2C%20elegant%20calm%20composition&width=900&height=700&seq=safety-main-v3&orientation=portrait"
                  alt="AcBuy spreadsheet safety"
                  className="w-full h-[400px] md:h-[500px] object-cover object-top"
                />
                <div className="absolute top-4 left-4 flex items-center gap-2 flex-wrap">
                  <span className="px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-semibold text-foreground-800">Verified</span>
                  <span className="px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-semibold text-foreground-800">Safe</span>
                  <span className="px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-semibold text-foreground-800">2026</span>
                </div>
              </div>
            </div>

            <div className="lg:w-1/2 flex flex-col justify-center">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-5">
                Is AcBuy Spreadsheet Safe?
              </h2>

              <div className="flex items-center gap-3 mb-6 flex-wrap">
                <span className="px-4 py-1.5 rounded-full border border-foreground-300 text-xs font-medium text-foreground-700">Community Verified</span>
                <span className="px-4 py-1.5 rounded-full text-xs font-medium text-foreground-600">Updated Daily</span>
                <span className="px-4 py-1.5 rounded-full text-xs font-medium text-foreground-600">Trusted Links</span>
              </div>

              <div className="bg-foreground-950 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6">
                <div className="flex-1">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-900/40 text-accent-300 text-xs font-semibold mb-4">Safety First</span>
                  <h3 className="text-lg font-bold text-background-50 mb-3">Shop With Confidence</h3>
                  <p className="text-sm text-background-50/70 leading-relaxed">
                    The AcBuy Spreadsheet includes only community-vetted seller links. Every entry is reviewed for accuracy, and the spreadsheet is refreshed daily to remove outdated or broken links. While we strive for accuracy, always verify sellers and inspect QC photos before purchasing.
                  </p>
                </div>
                <div className="md:w-32 flex-shrink-0">
                  <div className="w-full md:w-28 h-28 rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Minimalist%20trust%20and%20verified%20badge%20design%20on%20warm%20cream%20background%2C%20clean%20simple%20modern%20icon%2C%20soft%20lighting%2C%20professional%20style%2C%20elegant%20design%20elements%2C%20subtle%20gold%20accents&width=300&height=300&seq=safety-badge-v3&orientation=squarish"
                      alt="Trust badge"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>

              <Link
                to="/acbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                Read Complete Safety Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}